<template>
<div class="comment">
    <div class="comment__title">Эксперт №{{ index }} - {{ value.name }}</div>
    <div class="comment__text" v-if="expanded && value.comment">{{ value.comment }}</div>
    <div class="comment__text comment__text_empty" v-else-if="expanded && !value.comment">Эксперт не оставил комментарий</div>
</div>
</template>

<script>
export default {
    name: "ExpertPanelReviewAssessmentSuperComment",
    props: {
        index: Number,
        value: Object,
        expanded: Boolean,
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.comment {
  margin-bottom: rem(16);
  &__title {
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(22);
    color: #2A2626;
  }
  &__text {
    padding: rem(16);
    background: #F9F9FA;
    border-radius: rem(16);
    margin-top: rem(6);
    margin-bottom: rem(24);
    font-weight: 400;
    font-size: rem(16);
    line-height: rem(22);
    color: #2A2626;


    &_empty {
      color: #C0C0C0;
    }
  }
}
</style>